export interface ListPageState {
    filter: any;
    page: number;
    pageSize: number;
    sort: any;
    filtertype:number;
}

export interface ListState {
    lists: {
        [key: string]: ListPageState;
    };
}

export const initialState: ListState = {
    lists: {}
};